export default __webpack_public_path__ + "static/media/logo192.78cfd8df.png";